<template lang="pug">
.episode-list-item
  article.card.is-paddingless(:class="{ 'is-hoverable': hoverable }")
    .card-image
      router-link(:to="{ name: 'episode', params: { id: episode.id } }")
        b-icon.premium-icon(icon="lock-alt" pack="fas" v-if="episode.is_premium")
        b-icon.play-icon(icon="play-circle-outline" size="is-large")
        figure.image.is-16by9
          cl-img(
            :cl-id="episode._embedded.artwork.cl_id"
            :transform="{ width: 726, height: 408 }"
          )
    .card-content
      .card-grow
        .card-title
          router-link.sub(
            v-if="collection"
            :to="{ name: 'collection', params: { id: collection.id } }"
          ) {{ collection.title | truncate(35) }}
          .sub(v-else-if="channel") {{ channel.title }}
          router-link.main(:to="{ name: 'episode', params: { id: episode.id } }") {{ episode.title | truncate(45) }}
        .card-desc(@click="redirect")
          p {{ episode.long_desc | truncate(180) }}
      .card-meta
        .level.is-mobile
          .level-left
            .level-item
              span {{ episode.pub_date | date('MMM D, YYYY') }}
            .level-item
              span {{ episode._embedded.speaker.full_name }}
      //- .card-meta
</template>

<script>
export default {
  name: 'episode-list-item',
  computed: {
    channel() {
      const { channels } = this.episode._embedded;
      if (channels && channels.length > 0) {
        return channels[0];
      }
      return null;
    },
    collection() {
      const { collections } = this.episode._embedded;
      if (collections && collections.length > 0) {
        return collections[0];
      }
      return null;
    },
    episode() {
      return this.value;
    },
  },
  methods: {
    redirect() {
      this.$router.push({
        name: 'episode',
        params: {
          id: this.episode.id,
        },
      });
    },
  },
  props: {
    hoverable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.episode-list-item {
  @include listItem;
}
</style>

<style theme="ffc" lang="scss">
.episode-list-item {
  article {
    .card-content {
      border-color: #eaeaea;
    }
  }
}
</style>

<style theme="cwo" lang="scss">
.episode-list-item {
  box-shadow: 0 0 30px rgba(0,0,0,0.1);
  article {
    border-radius: 4px;
    overflow: hidden;
  }
}
</style>
